<template>
    <div>
        <header class="nav-top">
            <top-menu/>
        </header>
        <div class="sidebar" :style="sideBarStyle">
            <div class="sidebar-wrapper">
                <el-menu
                    router
                    :collapse="isCollapse"
                    :collapse-transition="false"
                    :default-active="letMenu"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose">
                    <el-submenu index="1">
                        <template slot="title">
                            <i class="el-icon-data-analysis"></i>
                            <span>{{ $strings('word/menu_trx') }}</span>
                        </template>
                        <el-menu-item index="/spsite/trx/summary">TRX SUMMARY</el-menu-item>
                        <el-menu-item index="/spsite/trx/detail">TRX DETAIL</el-menu-item>
                    </el-submenu>
                    <el-submenu index="2">
                        <template slot="title">
                            <i class="el-icon-orange"></i>
                            <span>{{ $strings('word/menu_sp') }}</span>
                        </template>
                        <el-menu-item index="/spsite/sp">SP</el-menu-item>
                        <el-menu-item index="/spsite/spapp">SP-APP</el-menu-item>
                        <el-menu-item index="/spsite/smppnode">SP-SMPP-NODE</el-menu-item>
                    </el-submenu>
                    <el-submenu index="3">
                        <template slot="title">
                            <i class="el-icon-guide"></i>
                            <span>{{ $strings('word/menu_cp') }}</span>
                        </template>
                        <!--                        <el-menu-item-group>-->
                        <el-menu-item index="/spsite/cp">{{ $strings('spsite/menu_cp') }}</el-menu-item>
                        <el-menu-item index="/spsite/cpapp">{{ $strings('spsite/menu_cp_app') }}</el-menu-item>
                        <el-menu-item index="/spsite/tpl">{{ $strings('spsite/menu_cp_templates') }}</el-menu-item>
                        <el-menu-item index="/spsite/cppack">{{ $strings('spsite/menu_cp_pack') }}</el-menu-item>
                        <!--                        </el-menu-item-group>-->
                    </el-submenu>
                    <el-submenu index="4">
                        <template slot="title">
                            <i class="el-icon-ice-tea"></i>
                            <span>{{ $strings('word/test') }}</span>
                        </template>
                        <el-menu-item index="/spsite/test">{{ $strings('spsite/menu_test_trx') }}</el-menu-item>
                    </el-submenu>
                </el-menu>
                <div class="sidebar-collapse" @click="toggleSidebar">
                    <el-tooltip class="item" effect="dark" :content="$strings('word/toggle_sidebar')" placement="right">
                        <i class="el-icon-menu" style="transform: rotate(45deg);"></i>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <main class="main" :style="mainStyle">
            <router-view/>
        </main>
    </div>
</template>

<script>

import TopMenu from '@/components/topmenu';
import {GetItem, SaveItem} from "@/utils/storage";
import {STORAGE_KEY_TOGGLE_SIDEBAR} from "@/config/config";

export default {
    name: "home",
    components: {TopMenu},
    data() {
        return {
            isCollapse: false,
            letMenu: "/spsite/cp",
        }
    },
    created() {
        this.isCollapse = GetItem(STORAGE_KEY_TOGGLE_SIDEBAR) === 'Y';
    },
    mounted() {
        let pathName = window.location.hash.substr(1);
        if (pathName !== this.letMenu) {
            this.letMenu = pathName
        }
    },
    computed: {
        sideBarStyle: function () {
            return this.isCollapse ? {width: '4em'} : {width: '16em'}
        },
        mainStyle: function () {
            return this.isCollapse ? {paddingLeft: '4em'} : {paddingLeft: '16em'};
        }
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        toggleSidebar() {
            this.isCollapse = !this.isCollapse;
            SaveItem(STORAGE_KEY_TOGGLE_SIDEBAR, this.isCollapse ? 'Y' : 'N')
        },
    }
}
</script>

<style lang="scss">
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
    font-weight: bold;
}
</style>

<style scoped lang="scss">

@import "src/assets/css/var";

$color-border-base: #dcdfe6;
$site_bar_width: 16em;

.nav-top {
    border-bottom: 1px solid $color-border-base;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 9;
}

.sidebar {
    position: fixed;
    top: 62px;
    bottom: 0;
    z-index: 1;
    left: 0;
    width: $site_bar_width;
    border-right: 1px solid $color-border-base;
}

.sidebar-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-menu-vertical-demo {
        flex-grow: 1;
        border-right: none;

        .el-menu-item.is-active {
            font-weight: bold;
            border-right: 3px solid $primary-color
        }
    }

    .sidebar-collapse {
        cursor: pointer;
        padding: 1.5em;
    }
}

.main {
    padding-left: $site_bar_width;
}
</style>